<app-dialog-header [title]="'Detalhes do ingresso'"></app-dialog-header>

<mat-dialog-content class="body-ingresso">
  <img
    src="./../../../assets/images/footer/yes7-ticket-logo-footer.png"
    alt="logo yes seven ticket"
    style="width: 60%" />
  <div class="ticket-user-data">
    <div class="container d-flex justify-content-between">
      <p class="h6 text-dark">Nome:</p>
      <p class="h6 text-right">{{ ticket.user_name }} {{ ticket.user_last_name }}</p>
    </div>
    <div class="container d-flex justify-content-between">
      @if (ticket.user_cpf) {
        <p class="h6 text-dark">Documento CPF:</p>
        <p class="h6 text-right">{{ maskCpf(ticket.user_cpf) }}</p>
      } @else if (ticket.user_identity_card) {
        <p class="h6 text-dark">Documento Identidade (Internacional):</p>
        <p class="h6 text-right">{{ ticket.user_identity_card }}</p>
      }
    </div>
    <div class="container d-flex justify-content-between">
      <p class="h6 text-dark">Ingresso:</p>
      <p class="h6 text-right">
        {{ ticket.title }}
      </p>
    </div>
    <div class="container d-flex justify-content-between">
      <p class="h6 text-dark">Evento:</p>
      <p class="h6 text-right">
        {{ ticket.event_title }}
      </p>
    </div>
    <div class="container d-flex justify-content-between">
      <p class="h6 text-dark">Data do evento:</p>
      <p class="h6 text-right">
        {{ ticket.event_start_date | date: "dd/MM/yyyy" }} {{ ticket.event_start_date | date: " HH:mm" }}
      </p>
    </div>
    <div class="container d-flex justify-content-between">
      <p class="h6 text-dark">Local do evento:</p>
      <p class="h6 text-right" style="max-width: 50%">
        {{ ticket.event_location.location_name }} - {{ ticket.event_location.street }},
        {{ ticket.event_location.number }} - {{ ticket.event_location.city_name }}
        <!-- {{ ticket.event_location.state }} -->
      </p>
    </div>
  </div>

  <div class="container d-grid justify-content-center">
    <img [src]="ticket.qr_code" style="width: 20em" alt="QR Code" />
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <app-button type="button" styleType="secondary" (click)="dialogRef.close()">Fechar</app-button>
</mat-dialog-actions>
